import React from 'react';

const PricingPage = () => {
  return (
    <iframe 
      src="/pricing.html"
      title="Pricing"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
    />
  );
};

export default PricingPage;
